export default __webpack_public_path__ + "static/media/buildings-right.dff81c72.svg";